/*
*
*  Reducer Factory
*
*  This methoed creates a reducer with the default data handling pattern I've designed.
*  The reducer should handle all data coming from the API. Data of a particular type (ie: User) is always
*  assigned to a reducer of that type.
*
*  Every action taken toward that data type is stored in the same flat state.
*
*  Components which use this data, use it by reference, not by storing a duplicate of the object.
*  Each individual component stores it's subgrouping of the items (ie: Pages), including their sort order if necessary
*  Any requests for additional records are made at the component level but trigger actions which add, remove, or update items in the store.
*
*  When sorting or subdividing the data is necessary, that state should be stored at the component level.
*  (ie: Loading states and pagination).
*
*  How would the state change when data is being requested?
*  A component makes a request by using an action creator. The state of this request promise is what's used to indicate loading.



    <Component onSubmit={this.props.userCreate}/>



    When the promise is fulfilled the loading state should be removed. OnSuccess, OnError should follow.

    How do paginated interfaces know about their page from the response.
    // Each view needs to know what the shape of their data is. They need to store an array of objects they contain,
    // So what comes back from the response is the array of IDs, page, total count.

    How can the api adjust to retrieve the next page of the request.
*
*
* */

import { normalize } from "normalizr";
// import React from 'react'

/*
 *
 * Creates actions
 *
 * _RECEIVED : Fired when promise is re
 * _UPDATING : Set a record in the store to "Loading"
 *
 *
 * */
export const reducerFactory = (name, label, schema = false, key = false) => {
  const normalizedData = (originalData) =>
    normalize(originalData, { data: [schema] });

  let initialState;

  if (schema) {
    initialState = { byId: {} };
  } else {
    initialState = [];
  }

  return (state = initialState, action) => {
    const { type, data } = action;

    switch (type) {
      case `${name}_RECEIVED`:
        if (schema) {
          return {
            ...state,
            // Could be any number of items, if they exist already, update them and change any loading states.
            byId: {
              ...state.byId,
              ...normalizedData(action.data).entities[label],
            },

            //foreach action.data, byId remove updating, add to allIds
          };
        } else {
          if (key) {
            let keyData = {};
            keyData[key] = action.data.data;
            return { ...state, ...keyData };
          } else {
            return [...action.data.data];
          }
        }

      // Mark the single data object as isFetching, this will provide loading state on the single object level.
      case `${name}_UPDATING`:
        let newState = { ...state };
        newState.byId[data.id].isLoading = true;

        return {
          ...newState,
          //foreach action.data, byId set them to updating...
        };

      case `${name}_RESET`:
        return initialState;

      default:
        return state;
    }
  };
};

// Each new data object
// export const createNamedWrapperReducer = (reducerName, reducerFunction = ReducerFactory) => {
//     return (state, action) => {
//
//         const {name} = action;
//
//         const isInitializationCall = state === undefined;
//
//         if(name !== reducerName && !isInitializationCall) return state
// ​
//         return reducerFunction(state, action)
//     }
// }
